var moduleMap = {
	"./handlers": () => {
		return Promise.all([__webpack_require__.e(821), __webpack_require__.e(866), __webpack_require__.e(968), __webpack_require__.e(100), __webpack_require__.e(286)]).then(() => (() => ((__webpack_require__(38888)))));
	},
	"./mountComponent": () => {
		return Promise.all([__webpack_require__.e(277), __webpack_require__.e(866), __webpack_require__.e(95), __webpack_require__.e(746), __webpack_require__.e(100), __webpack_require__.e(404)]).then(() => (() => ((__webpack_require__(63736)))));
	},
	"./mfeConfig": () => {
		return __webpack_require__.e(89).then(() => (() => ((__webpack_require__(67089)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});